import { recipe } from "@vanilla-extract/recipes";
import { rem } from "@huub-web/utils/css/rem";
import { style } from "@vanilla-extract/css";

import { theme } from "../../theme/css/theme.css";
import { responsive } from "../../utils/responsive";
import { spacingVariants } from "../../utils/vanilla/spacingVariants";

export const containerStyle = style({
  // Keep
});

const spacing = responsive({
  base: {
    paddingLeft: theme.spacings.s,
    paddingRight: theme.spacings.s,
    gap: theme.spacings.m,
  },
  s: {
    paddingLeft: theme.spacings.m,
    paddingRight: theme.spacings.m,
    gap: theme.spacings.l,
  },
  m: {
    gap: theme.spacings.xl,
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
}) as any;

export const baseContainerStyle = recipe({
  base: {
    position: "relative",
    width: "100%",
    display: "flex",
    flexDirection: "column",
    marginLeft: "auto",
    marginRight: "auto",
    flexShrink: 0,
    containerName: "container",
    containerType: "inline-size",
    vars: {
      "--max-width": "calc(var(--container-width, 100%))",
    },
  },
  variants: {
    grow: {
      true: {
        flexGrow: 1,
      },
      false: {
        flexGrow: 0,
      },
    },
    gap: {
      ...spacingVariants("gap", true),
    },
    size: {
      none: {},
      default: {
        ...spacing,
      },
      xs: {
        ...spacing,
        vars: {
          "--max-width": rem(460),
        },
      },
      s: {
        ...spacing,
        vars: {
          "--max-width": rem(680),
        },
      },
      marketing: {
        ...spacing,
        vars: {
          "--max-width": rem(1200),
        },
      },
      marketingS: {
        ...spacing,
        vars: {
          "--max-width": rem(820),
        },
      },
    },
    variant: {
      default: {
        maxWidth: "var(--max-width)",
      },
      none: {},
    },
    stretch: {
      true: {
        maxWidth: "none",
      },
    },
  },
  defaultVariants: {
    variant: "default",
    size: "default",
  },
});
